import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ZidButton, ZidIcon, ZidModal } from '@zidsa/ui';

import { I18nMessages } from '../../../../i18n/messages';
import { HermesOtlStoreModule } from '../../../../account/store/hermes-otl.module';
import isProduction from '../../../helpers/is-production';
import isRTL from '../../../helpers/is-lang-arabic';

import styles from './HermesRedirect.scss';

@Component
export class HermesRedirectModalComponent extends Vue {
  @Prop({
    required: true,
  })
  private readonly isOpen!: boolean;

  private isLoading = false;

  render(h: CreateElement): VNode {
    return (
      <ZidModal visible={this.isOpen} onClose={this.onCloseModal} class={styles.modal}>
        <div class={styles.modal__icon}>
          <ZidIcon icon='star_outline' color='primary' />
        </div>
        <div class={styles.modal__message}>
          {this.$t(I18nMessages['hermes.redirect.modal.appmarket.message'])}
        </div>
        <footer class={styles.modal__footer}>
          <ZidButton onClick={this.onClickNavigateToHermes} class={styles.modal__button} isLoading={this.isLoading}>
            {this.$t(I18nMessages['hermes.redirect.modal.button'])}
          </ZidButton>
        </footer>
      </ZidModal>
    );
  }

  private async onClickNavigateToHermes(): Promise<void> {
    this.isLoading = true;
    try {
      const { token } = await HermesOtlStoreModule.getHermesOtl();
      const lang = isRTL() ? 'ar-sa' : 'en-sa';
      const baseUrl = isProduction() ? 'https://dashboard.zid.sa' : 'https://hermes.zid.dev';

      if (token) {
        window.location.href = `${baseUrl}/${lang}/login/otl/${token}`;
      }
    } catch (error) {
      console.error('Failed to redirect to Hermes:', error);
    } finally {
      this.isLoading = false;
    }
  }

  private onCloseModal(): void {
    this.$emit('close');
  }
}
